import CheckboxOutline from 'assets/icons/md/md-checkbox-outline.svg'

CheckboxOutline.displayName = 'CheckboxOutline'
export default CheckboxOutline
